import { useState } from 'react';

const usePdfConfirmModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const open = (reportData) => {
    setData(reportData);
    setIsOpen(true);
    setIsLoading(false);
  };

  const close = () => {
    setIsOpen(false);
    setData(null);
    setIsLoading(false);
  };

  const confirm = () => {
    close();
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  return {
    show: isOpen,
    data,
    open,
    close,
    confirm,
    isLoading,
    setLoading,
  };
};

export default usePdfConfirmModal;
